import React from "react";

import Placeholder from "@/pages/Placeholder";

// Before launch, all authorized visitors see the same development notice.
// Keep the existing /architect routes and the underlying Architect implementation intact.
export default function ArchitectGate() {
  return (
    <Placeholder
      title="Интеллект вкуса"
      subtitle="В разработке"
      description="Инструмент «Интеллект вкуса» находится в разработке. Мы откроем это пространство, когда оно будет готово."
    />
  );
}
